import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "./base/ProtectedRoute";
import PublicRoute from "./base/PublicRoute";
import AuthContainer from "./components/AuthContainer/Auth";
import CoachDetails from "./components/CoachDetails/CoachDetails";
import CoachPanel from "./components/CoachPanel/CoachPanel";

import { AUTH_ROUTE, COACH_DETAILS, COACH_PANEL, XRAY } from "./data/RouteUrls";
import * as actions from "./components/sharedRedux/sharedAction";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export function AppRoutes() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getGloassaryWords());
  }, []);
  return (
    <Switch>
      {/* Straight to X-Ray, the coach's actual home. `COACH_PANEL` is a
          prefix with no route of its own, so redirecting there just handed
          the work to CoachPanel's wildcard. */}
      <Route exact path="/">
        <Redirect to={XRAY} />
      </Route>
      <PublicRoute path={AUTH_ROUTE} component={AuthContainer} />
      <ProtectedRoute path={COACH_PANEL} component={CoachPanel} />
      <ProtectedRoute path={COACH_DETAILS} component={CoachDetails} />
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  );
}
